// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1JNXG","disabled":"FileBtn_disabled__1uWin","warn":"FileBtn_warn__3lSJ0","fade":"FileBtn_fade__3DgDU"};